import React from 'react';

/**
 * LocalBusinessSchema Component
 * Critical for local SEO and "near me" searches
 * Helps your business appear in Google Maps and local pack
 * 
 * IMPORTANT: Renders inline so Google can see it on first crawl
 */
const LocalBusinessSchema = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://audioandco.com/#localbusiness",
    "name": "Audio & Co®",
    "alternateName": "Audio and Co",
    "description": "Professional audio, video & publishing services. Done-for-you podcast production, YouTube management, book publishing, and mobile app development for SMEs.",
    "url": "https://audioandco.com",
    "telephone": "+44-XXX-XXX-XXXX",
    "email": "hello@audioandco.com",
    "image": "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=1200&h=630&fit=crop",
    "logo": "https://audioandco.com/logo.png",
    "priceRange": "££-£££",
    "currenciesAccepted": "GBP, USD, EUR",
    "paymentAccepted": "Credit Card, Bank Transfer, PayPal",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "GB",
      "addressRegion": "England"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "51.5074",
      "longitude": "-0.1278"
    },
    "areaServed": [
      {"@type": "Country", "name": "United Kingdom"},
      {"@type": "Country", "name": "United States"},
      {"@type": "Country", "name": "Canada"},
      {"@type": "Country", "name": "Australia"},
      {"@type": "Country", "name": "Ireland"}
    ],
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "51.5074",
        "longitude": "-0.1278"
      },
      "geoRadius": "50000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Audio & Co Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Podcast Production",
            "description": "Complete podcast production services from concept to launch"
          },
          "priceSpecification": {
            "@type": "PriceSpecification",
            "price": "350",
            "priceCurrency": "GBP",
            "minPrice": "350"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Book Publishing",
            "description": "Self-publishing services for Amazon Kindle, paperback, and hardback"
          },
          "priceSpecification": {
            "@type": "PriceSpecification",
            "price": "195",
            "priceCurrency": "GBP",
            "minPrice": "195"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Mobile App Development",
            "description": "Custom mobile app development for small businesses"
          },
          "priceSpecification": {
            "@type": "PriceSpecification",
            "price": "3995",
            "priceCurrency": "GBP",
            "minPrice": "3995"
          }
        }
      ]
    },
    "review": [
      {
        "@type": "Review",
        "author": {"@type": "Person", "name": "Sarah M."},
        "datePublished": "2025-01-15",
        "reviewBody": "Audio & Co helped me launch my podcast and it hit the top charts within weeks. Incredible service!",
        "reviewRating": {"@type": "Rating", "ratingValue": "5", "bestRating": "5"}
      },
      {
        "@type": "Review",
        "author": {"@type": "Person", "name": "David R."},
        "datePublished": "2025-02-01",
        "reviewBody": "Published my first book with Audio & Co. They handled everything professionally. 100% recommend!",
        "reviewRating": {"@type": "Rating", "ratingValue": "5", "bestRating": "5"}
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/audioandco",
      "https://twitter.com/audioandco",
      "https://www.instagram.com/audioandco",
      "https://www.linkedin.com/company/audioandco"
    ]
  };

  return (
    <script
      type="application/ld+json"
      data-schema="localbusiness"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
    />
  );
};

export default LocalBusinessSchema;
